<template>
  <div class="full-height linear-main3">
    <ld-header
      @click-left="$router.replace({path:'/userCenter/NeedOrder', query: {type: 'hotel'}})"
      transparent
      white
    >
      询价单详情
    </ld-header>
    <mescroll-vue
      class="wrapperhtquirydetail"
      ref="mescroll"
      :down="mescrollDown"
      @init="mescrollInit"
    >
      <div class="box">
        <div class="white pd10-0">
          <van-row class="font-lg font24 mt5">
            <span class="pd0-8">{{ detail.ddztRemark }}</span>
          </van-row>
          <van-row class="font12 mt5">
            <p class="pd0-10">
              您可通过下拉刷新操作获取最新消息~
            </p>
          </van-row>
        </div>

        <div>
          <van-cell-group class="mb5 round-sm overflow">
            <van-cell
              :title="detail.cityName+'-'+(detail.jdmc||'')"
              :label="detail.address"
            />
            <van-cell
              :title="`${detail.fxmc} ${detail.rooms}间`"
            >
              <div slot="title">
                {{ detail.fxmc }} <span class="cff4f3f">{{ detail.rooms }}</span>{{ $t('E205','间') }}
              </div>
            </van-cell>
            <van-cell
              :title="`${detail.rzrq} ${detail._rzrqweek} 至 ${detail.ldrq} ${detail._ldrqweek} 共${detail.nights}晚`"
            >
              <div slot="title">
                {{ detail.rzrq }} {{ detail._rzrqweek }} {{ $t('H041','至') }} {{ detail.ldrq }} {{ detail._ldrqweek }} {{ $t('E017','共') }}<span class="cff4f3f">{{ detail.nights }}</span>晚
              </div>
            </van-cell>
            <van-cell :title="$t('H226','备注')+detail.bzbz" />
          </van-cell-group>

          <div
            class="mb5 bg-white round-sm"
            style="padding: 0 16px;"
          >
            <div class="Grid">
              <div style="line-height: 65px;">
                {{ $t('D022','联系信息') }}
              </div>
              <div class="Grid-cell">
                <van-cell-group>
                  <van-cell
                    :title="`${detail.linkman}(${detail.linkMobile})`"
                    :label="detail.linkEmail ? '邮箱('+detail.linkEmail+')' : '邮箱()'"
                  />
                </van-cell-group>
              </div>
            </div>
          </div>

          <div class="mb5 refundDetail--box pd80 round-sm">
            <div class="Grid">
              <div class="Grid-cell">
                <div class="mb10 font16">
                  留言板
                </div>
                <div
                  v-for="(item, index) in noteList"
                  :key="index"
                >
                  <div class="mb10 font12 text-center cccc">
                    {{ item.noteDate }}
                  </div>
                  <div
                    class="mb10"
                    :style="{'text-align': item.czly == '1' ? 'right' : 'left'}"
                  >
                    <p class="main-color">
                      {{ item.czly == '1' ? item.noteBy : '客服' }}
                    </p>
                    <p>{{ item.note }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <div class="Grid">
      <van-field
        v-model="model.note"
        center
        clearable
        placeholder="请输入留言内容"
      >
        <template #button>
          <ld-button
            main
            size="sm"
            @click="submit"
          >
            发 送
          </ld-button>
        </template>
      </van-field>
    </div>
  </div>
</template>

<script>
import { CellGroup, Cell ,Field} from 'vant'
import hotelNeedOrderInteractor from 'Views/Home/userCenter/NeedOrder/use-cases/hotelNeedOrder-interactor'
import { formatDate } from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'

export default {
  name:'HtInquiryDetail',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    ldButton,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      detail: {},
      noteList: [],
      model: {
        note: '',
        orderId: ''
      },
      isLoading: false,
      mescrollDown: {
        callback: this.downCallback,
      },
    }
  },
  created() {
    /**
		 * 初始化数据
		 */
    this.model.orderId = this.id
    this.loadData()
  },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    async loadData() {
      const { data } = await hotelNeedOrderInteractor.getHotelNeedOrderById(
        this.id
      )
      this.detail = data
      this.detail._rzrqweek = formatDate(this.detail.rzrq).week
      this.detail._ldrqweek = formatDate(this.detail.ldrq).week

      const {
        data: noteList
      } = await hotelNeedOrderInteractor.getHotelNeedNoteById(this.id)
      this.noteList = noteList
      this.isLoading = false
      this.mescroll.endSuccess()
    },
    async submit() {
      if (!this.model.note) return this.$toast('留言内容不能为空！')
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g
      if(this.model.note.match(regRule)) {
        this.model.note = this.model.note.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '')
        return this.$toast('不支持表情')
      } 

      await hotelNeedOrderInteractor.updateHotelNeedNoteById(this.model)

      this.model.note = ''
      this.$toast('留言成功！')
      this.loadData()
    },
    downCallback () {
      this.loadData()
    },
  }
}
</script>

<style lang="less" scoped>
@import '~Assets/styles/currency/ht.less';
.box{
    padding: 10px;
}
.refundDetail--box {
  background: #fff;
  padding: 10px 15px;
}
.pd80 {
  padding-bottom: 80px
}
.pd0-8 {
  padding: 0 8px;
}
.pd8 {
  padding: 8px;
}
.wrapperhtquirydetail{
    height: calc(100vh - 96px);
}
</style>
